import React, { Fragment } from 'react';
import classnames from 'classnames';
import PlainText from 'ati-ui-react/components/PlainText';
import Link from '@components/link';
import strings from '../../strings';
import * as styles from '../Rating/Rating.scss';
import { makeRatingFaqUrl, makeTopRatingFaqUrl } from '../../utils/urlProvider';

const Description = ({ isMobile }) => {
  const ratingFaqURL = makeRatingFaqUrl();
  const topRatingFaqUrl = makeTopRatingFaqUrl();

  return (
    <Fragment>
      <div className={styles.descriptionHeader}>
        <div
          className={styles.heading}
        >
          {strings.title}
        </div>
      </div>
      {isMobile && (
      <Link href={ratingFaqURL} className={styles.faq}>
        {strings.faq}
      </Link>
      )}
      {!isMobile && (
      <>
        <PlainText
          size="medium"
          className={styles.paragraph}
        >
          {strings.paragraph}
        </PlainText>
        <div className={styles.certificates}>
          <PlainText
            size="medium"
          >
            {strings.best}
          </PlainText>
          <a
            target="_blank"
            className={classnames(styles.link, 'glz-link', 'glz-is-large', 'glz-is-primary', 'glz-is-underline')}
            href={topRatingFaqUrl}
            rel="noreferrer"
          >
            {strings.presents}
          </a>
          <PlainText
            size="medium"
          >
            {strings.dot}
          </PlainText>
        </div>
      </>
      )}
    </Fragment>
  );
};

export default Description;
